<script lang="ts">
  import type { Snippet } from "svelte";

  interface Props {
    type?: "error" | "success" | "warning" | "info";
    title?: string;
    class?: string;
    children?: Snippet;
  }

  const { type = "error", title, class: extraClass = "", children }: Props = $props();

  const typeClass = $derived(`alert-${type}`);
</script>

<div class="alert-banner {typeClass} {extraClass}" role={type === "error" ? "alert" : "status"}>
  <div class="alert-icon" aria-hidden="true">
    {#if type === "error"}
      ✕
    {:else if type === "success"}
      ✓
    {:else if type === "warning"}
      !
    {:else}
      i
    {/if}
  </div>
  <div class="alert-body">
    {#if title}
      <strong class="alert-title">{title}</strong>
    {/if}
    <div class="alert-text">
      {@render children?.()}
    </div>
  </div>
</div>

<style>
  .alert-banner {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    border-radius: var(--radius-sm, 6px);
    font-size: 0.85rem;
    line-height: 1.4;
    margin-bottom: 1rem;
  }

  .alert-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    font-size: 0.75rem;
    font-weight: bold;
    flex-shrink: 0;
    margin-top: 0.1rem;
  }

  .alert-body {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
  }

  .alert-title {
    font-weight: 600;
  }

  .alert-error {
    background: rgba(235, 87, 87, 0.1);
    border: 1px solid rgba(235, 87, 87, 0.3);
    color: var(--mars-light, #ff6b4a);
  }
  .alert-error .alert-icon {
    background: rgba(235, 87, 87, 0.2);
  }

  .alert-success {
    background: rgba(46, 204, 113, 0.1);
    border: 1px solid rgba(46, 204, 113, 0.3);
    color: var(--green, #2ecc71);
  }
  .alert-success .alert-icon {
    background: rgba(46, 204, 113, 0.2);
  }

  .alert-warning {
    background: rgba(243, 156, 18, 0.1);
    border: 1px solid rgba(243, 156, 18, 0.3);
    color: var(--amber, #f39c12);
  }
  .alert-warning .alert-icon {
    background: rgba(243, 156, 18, 0.2);
  }

  .alert-info {
    background: rgba(52, 152, 219, 0.1);
    border: 1px solid rgba(52, 152, 219, 0.3);
    color: var(--blue, #3498db);
  }
  .alert-info .alert-icon {
    background: rgba(52, 152, 219, 0.2);
  }
</style>
